import substrateSuggestions from '../services/substrateSuggestions';
import { action } from 'satcheljs/lib/legacy';
import { initializeBindStatusLazy } from 'owa-linkedin';

export default action('execute3SPrimeCall')(async function execute3SPrimeCall() {
    await initializeBindStatusLazy.importAndExecute();

    // Execute the 3S prime call
    substrateSuggestions('', false /*includeDirectory*/, false /*includeFeatureData*/);
});
